export type StatusVariant =
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "light"
  | "dark";

const STATUS_VARIANT_MAP: Record<string, StatusVariant> = {
  active: "primary",
  analyzed: "info",
  cancelled: "danger",
  complete: "success",
  completed: "success",
  confirmed: "info",
  created: "secondary",
  draft: "warning",
  failed: "danger",
  finalized: "success",
  in_progress: "warning",
  "in progress": "warning",
  in_review: "primary",
  no_show: "dark",
  pending: "secondary",
  pending_review: "info",
  preprocessing: "warning",
  processing: "warning",
  reported: "primary",
  reviewed: "primary",
  scheduled: "info",
  unread: "danger",
  uploaded: "info",
};

export function getStatusVariant(status?: string | null): StatusVariant {
  if (!status) return "secondary";
  const normalized = status.toLowerCase().trim();
  return STATUS_VARIANT_MAP[normalized] || "secondary";
}

export function formatStatusLabel(status?: string | null): string {
  if (!status) return "Unknown";
  return status
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
